import { useRef, useState, useEffect } from 'react';
import useAuth from '../../hooks/useAuth';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import qs from 'qs';
import {
    CardBody,
    InputGroup,
    CardImg,
    Form,
    Label,
    Input,
    Button,
    InputGroupText
  } from "reactstrap";
import { BiUser, BiLockOpen } from 'react-icons/bi';

const Login = () => {
    const { setAuth } = useAuth();

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const userRef = useRef();
    const errRef = useRef();

    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [errMsg, setErrMsg] = useState('');

    useEffect(() => {
        userRef.current.focus();
    }, [])

    useEffect(() => {
        setErrMsg('');
    }, [user, pwd])

    const handleSubmit = async (e) => {
        e.preventDefault();
        let  data = qs.stringify({
            'grant_type': 'password',
            'username': user,
            'password': pwd
        });

        try {
            const response = await axios.post(process.env.REACT_APP_API_LOGIN_URL, data,
                {
                    auth: {
                        username: 'test-client-id',
                        password: 'test-client-secret'
                    }
                },
                {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    withCredentials: true
                }
            );
            const accessToken = response.data.access_token;
            const refreshToken = response.data.refresh_token;
            const roles = 'user';
            setAuth({ accessToken, refreshToken });
            setUser('');
            setPwd('');
            navigate(from, { replace: true });
        } catch (err) {
            console.log(err);
            if (!err?.response) {
                setErrMsg('No Server Response');
            } else if (err.response?.status === 400) {
                setErrMsg('Wrong Username or Password');
            } else if (err.response?.status === 401) {
                setErrMsg('Unauthorized');
            } else {
                setErrMsg('Login Failed');
            }
            errRef.current.focus();
        }
    }

    return (

        <div className="container card login-content" style={{width: '30rem'}}>
        <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
            {/* <h1 className="text-center">Sign In</h1> */}
            <CardImg variant="center" src="logo.png" style={{width: '15rem', display:'block', margin:'auto'}} />

            <CardBody>
                <Form onSubmit={handleSubmit}>
                    <Label htmlFor="username">Username</Label>
                    <InputGroup className="mb-3">
                    <InputGroupText id="basic-addon1"><BiUser /></InputGroupText>

                        <Input
                            type="text"
                            id="username"
                            ref={userRef}
                            autoComplete="off"
                            onChange={(e) => setUser(e.target.value)}
                            value={user}
                            required
                        />
                    </InputGroup>
                    <Label htmlFor="password">Password</Label>
                    <InputGroup className="mb-3">
                    <InputGroupText id="basic-addon1"><BiLockOpen /></InputGroupText>

                        <Input
                            type="password"
                            id="password"
                            onChange={(e) => setPwd(e.target.value)}
                            value={pwd}
                            required
                        />
                    </InputGroup>

                    <Button className='mt-4 login-btn'>Login</Button>
                </Form>
           
            </CardBody>

           
        </div>

    )
}

export default Login